import {Component, Input, OnInit} from '@angular/core';
import {Template} from "../../../../model/template";

@Component({
  selector: 'app-template-overview',
  templateUrl: './template-overview.component.html',
  styleUrls: ['./template-overview.component.scss']
})
export class TemplateOverviewComponent implements OnInit {

  @Input()
  public template: Template;

  constructor() {
  }

  ngOnInit(): void {
  }

}
